<template>
  <div class="special-background flex-box">
    <div style="width: 100%;">
      <img
        src="../../../public/svg/icon.svg"
        alt="hduhelper"
        style="width: 100%;"
        class="animate__animated animate__zoomIn"
      />

      <div
        class="animate__animated animate__fadeInDown"
        style="margin-bottom: 15vh;"
      >
        <span class="middle-font is-block">
          同学,您好
        </span>
        <span class="middle-font is-block">
          右划查阅您的图书馆数据总结
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'startPage',
}
</script>

<style scoped>
.flex-box {
  display: flex;
  z-index: 10;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.animate__animated.animate__zoomIn {
  --animate-duration: 0.5s;
}

.animate__animated.animate__fadeInDown {
  --animate-duration: 0.5s;
}

.special-background {
  background: linear-gradient(
    45deg,
    var(--hduhelp-blue),
    var(--hdu-school-blue),
    /*#23a6d5,*/ var(--eggplant-purple)
  );
  background-size: 100% 100%;
}
</style>
